import Layout from '../../companyAdmin/layout.vue'
import List from './list.vue'
import Editor from './editor.vue'

const basePath = '/v-admin/client-admin/site-message-management'

export default {
  path: `${basePath}`,
  redirect: `${basePath}/list`,
  component: Layout,
  meta: {
    isAllInclude: true,
    isNewPage: true,
    permission: ['PERM_MANAGE_SYSTEM_NOTIFICATION'],
    menu: {
      labelI18nKey: 'admin.company.siteMessageManagement.menu'
    }
  },
  children: [
    {
      path: `${basePath}/list`,
      component: List,
      meta: {
        breadcrumb: { hidden: true },
        isNewPage: true,
        titleI18nKey: 'admin.company.siteMessageManagement.title'
      }
    },
    {
      path: `${basePath}/add`,
      component: Editor,
      meta: {
        isNewPage: true,
        titleI18nKey: 'admin.company.siteMessageManagement.label.addNewNotification'
      }
    },
    {
      path: `${basePath}/view/:siteMessageId`,
      component: Editor,
      meta: {
        isNewPage: true,
        isView: true,
        titleI18nKey: 'admin.company.siteMessageManagement.label.viewNotification'
      }
    }
  ]
}
